import { components, OptionProps, GroupBase } from "react-select";

export const CheckboxOption = <Option, IsMulti extends boolean = true>(
  props: OptionProps<Option, IsMulti, GroupBase<Option>>,
) => {
  return (
    <components.Option {...props}>
      <div className="table-checkbox d-flex align-items-center gap-2">
        <input
          style={{ pointerEvents: "auto", cursor: 'pointer' }}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => props.selectOption(props.data)}
          onClick={(e) => e.stopPropagation()}
        />
        <span>{props.label}</span>
      </div>
    </components.Option>
  );
};
